var React = require('react');

function Zoom (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z","key":0}),React.createElement("path",{"d":"M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z","key":1})]);
}

Zoom.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Zoom;

Zoom.default = Zoom;
